import { IApplicationState, TBoardId } from '../../../../types/types';
import { getBoardUserMeta } from '../../boardUserMetas/selectors/getBoardUserMeta';

export const getBoardKNBCardColorTagsSearchUsed = (
    state: IApplicationState,
    boardId: TBoardId,
): boolean => {
    const userBoardMeta = getBoardUserMeta(state, boardId);
    return userBoardMeta && userBoardMeta.isKNBCardColorTagsSearchUsed;
};
